import { AsYouType } from 'libphonenumber-js/min';
import omit from 'lodash.omit';
var NUMERIC_REGEX = /[^0-9]/g;
export var removeNonNumbers = function removeNonNumbers(value) {
  return value.replace(NUMERIC_REGEX, '');
};
export var formatPhone = function formatPhone(value) {
  var numbers = removeNonNumbers(value); // prettier-ignore

  if (numbers.length > 10) {
    return "".concat(numbers.substring(0, 1), " (").concat(numbers.substring(1, 4), ") ").concat(numbers.substring(4, 7), "-").concat(numbers.substring(7));
  } else if (numbers.length > 6) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6), "-").concat(numbers.substring(6));
  } else if (numbers.length > 3) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6));
  }

  return numbers;
};
var formatterUS = new AsYouType('US');
var formatterCA = new AsYouType('CA');
var formatterAU = new AsYouType('AU');

var getValues = function getValues(formatter) {
  return function (value) {
    var formattedOutput = formatter.input(value);
    var number = omit(formatter.getNumber(), ['metadata']);
    var template = formatter.getTemplate();
    formatter.reset();
    return {
      formattedOutput: formattedOutput,
      number: number,
      template: template
    };
  };
};

var FORMATTERS = {
  US: getValues(formatterUS),
  CA: getValues(formatterCA),
  AU: getValues(formatterAU)
};
export var formatPhoneInternational = function formatPhoneInternational(country, value) {
  return FORMATTERS[country](value);
};